<app-z-dialog
  [title]="data.title | translate"
  [customTitleTemplate]="titleTemplate"
  [contentTemplate]="contentTemplate"
>
</app-z-dialog>

<ng-template #titleTemplate>
  <div class="workflow-action-dialog__header flex-grow-1">
    <h4 class="dialog-title s-mb-1 fw-bold c-white">
      {{ data.title | translate }}
    </h4>
    @if (data.message) {
      <p class="workflow-action-dialog__message">
        {{ data.message | translate }}
      </p>
    }
  </div>
</ng-template>

<ng-template #contentTemplate>
  <section class="workflow-action-dialog">
    <div class="workflow-action-dialog__grid">
      @for (actionItem of data.actions; track trackByActionId($index, actionItem)) {
        <button
          type="button"
          class="workflow-action-dialog__card"
          [class.workflow-action-dialog__card--disabled]="actionItem.disabled"
          [class.workflow-action-dialog__card--info]="(actionItem.tone || 'info') === 'info'"
          [class.workflow-action-dialog__card--success]="actionItem.tone === 'success'"
          [class.workflow-action-dialog__card--warning]="actionItem.tone === 'warning'"
          [class.workflow-action-dialog__card--neutral]="actionItem.tone === 'neutral'"
          [disabled]="actionItem.disabled"
          [attr.aria-label]="actionItem.label"
          (click)="handleAction(actionItem)"
        >
          <span class="workflow-action-dialog__icon" aria-hidden="true">
            <mat-icon>{{ actionItem.icon }}</mat-icon>
          </span>
          <span class="workflow-action-dialog__label">{{ actionItem.label | translate }}</span>
        </button>
      }
    </div>
  </section>
</ng-template>